import { useState, useEffect, useCallback } from 'react';
import type { ChangeEvent, ComponentProps } from 'react';
import { Check, Input, Label } from './Toggle.styles';

type ToggleProps = ComponentProps<'input'> & {
  label?: string;
  checked?: boolean;
};

const Toggle = ({
  label,
  checked = false,
  className,
  onChange,
  ...props
}: ToggleProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setIsChecked(event.target.checked);
      onChange?.(event);
    },
    [onChange],
  );

  return (
    <Label className={className}>
      <Input
        {...props}
        type="checkbox"
        defaultChecked={checked}
        onChange={handleChange}
      />
      <Check aria-hidden="true" $isChecked={isChecked} />
      {label}
    </Label>
  );
};

export { Toggle };
